var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"fullscreen-button",class:_vm.customClass,on:{"click":_vm.fullscreenToggle}},[_c('i',{class:`${_vm.isFullscreen ? 'fa fa-compress' : 'fa fa-expand'} video-icon`,attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }